export default __webpack_public_path__ + "static/media/lion-min.cbc02d8a.jpg";